import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static classes = ['animable', 'animated']

  connect() {
    setTimeout(() => {
      this.element.classList.remove(...this.animatedClasses)
    }, 200)

    document.addEventListener('turbo:before-stream-render', this.replace.bind(this))
  }

  disconnected() {
    document.removeEventListener('turbo:before-stream-render', this.replace.bind(this))
  }

  replace(event) {
    if (event.target.action !== 'replace' || document.querySelector(event.target.targets) !== this.element) return

    event.preventDefault()

    this.element.classList.add(...this.animableClasses)
    this.element.classList.add(...this.animatedClasses)

    setTimeout(() => {
      const newElement = event.target.templateElement.content.firstElementChild
      newElement.classList.add(...this.animableClasses)
      newElement.classList.add(...this.animatedClasses)
      event.target.performAction()
    }, 200)
  }
}
